module.exports = __webpack_public_path__ + "img/icon-location.53a343b0.svg";